/**
 * Urdu, keyed by the English source string.
 *
 * Anything missing falls through to English rather than to a key, so a new
 * sentence is readable the moment it ships and translatable afterwards.
 * Brand and rail names — Meal4ALL, JazzCash, Easypaisa — are deliberately
 * left in Latin script: that is how they are written on the wallets
 * themselves.
 */

export const ur: Record<string, string> = {
  // -------------------------------------------------------------- chrome
  'A MEAL - A SMILE - A BLESSING': 'ایک کھانا - ایک مسکراہٹ - ایک رحمت',
  'Open navigation menu': 'مینو کھولیں',
  'Go back': 'واپس جائیں',
  Continue: 'جاری رکھیں',
  Cancel: 'منسوخ کریں',
  Close: 'بند کریں',
  'Today is {date}.': 'آج {date} ہے۔',
  Select: 'منتخب کریں',
  Edit: 'تبدیل کریں',
  Share: 'شیئر کریں',
  Download: 'ڈاؤن لوڈ',
  Refresh: 'دوبارہ لوڈ کریں',
  'Try Again': 'دوبارہ کوشش کریں',
  Details: 'تفصیلات',
  Custom: 'اپنی مرضی کے مطابق',
  Verified: 'تصدیق شدہ',
  Since: 'سے',
  'Sort by': 'ترتیب دیں',

  // ---------------------------------------------------------------- home
  'A Meal from You,\nA Blessing for Them': 'آپ کی طرف سے کھانا،\nان کے لیے رحمت',
  "Your small contribution can fill someone's empty plate.":
    'آپ کا چھوٹا سا تعاون کسی کی خالی پلیٹ بھر سکتا ہے۔',
  'Nutritious Meals': 'غذائیت سے بھرپور کھانا',
  'Hygienic & Safe': 'صاف اور محفوظ',
  'Delivered with Care': 'خیال سے پہنچایا گیا',
  'Support a Meal': 'کھانے میں تعاون کریں',
  'More Features': 'مزید سہولتیں',
  'Coming Soon': 'جلد آ رہا ہے',
  'More features are coming soon': 'مزید سہولتیں جلد آ رہی ہیں',
  'My Donations': 'میرے عطیات',
  'How It Works': 'یہ کیسے کام کرتا ہے',
  'Your kindness brings hope to someone in need.':
    'آپ کی مہربانی کسی ضرورت مند کے لیے امید بنتی ہے۔',

  // --------------------------------------------------------- choose meal
  'Choose a Meal to Support': 'تعاون کے لیے کھانا منتخب کریں',
  'Nutritious meals prepared with love and care':
    'محبت اور خیال سے تیار کیا گیا غذائیت بخش کھانا',
  'No meals available right now': 'اس وقت کوئی کھانا دستیاب نہیں',
  'Please check back shortly — we are updating our menu.':
    'براہِ کرم تھوڑی دیر بعد دیکھیں — ہم مینو اپ ڈیٹ کر رہے ہیں۔',
  'How many people would you like to feed?': 'آپ کتنے افراد کو کھانا کھلانا چاہیں گے؟',
  'How many people?': 'کتنے افراد؟',
  'Number of people to feed': 'کھانا کھلانے والے افراد کی تعداد',
  'Custom number of people': 'افراد کی اپنی تعداد',
  'Enter Number': 'تعداد لکھیں',
  People: 'افراد',
  Meals: 'کھانے',
  'Per Person': 'فی فرد',
  'Price Per Person': 'فی فرد قیمت',
  'You selected': 'آپ نے منتخب کیا',
  'Total Amount': 'کل رقم',
  'Continue to Checkout': 'آگے بڑھیں',

  // ------------------------------------------------------------ checkout
  'Distribution Detail': 'تقسیم کی تفصیل',
  'Donor Info': 'عطیہ دہندہ',
  'Recipient Info': 'وصول کنندہ',
  'Payment Info': 'ادائیگی',
  'Review Order': 'نظرثانی',
  'Order Details': 'آرڈر کی تفصیل',
  'Distribution Date': 'تقسیم کی تاریخ',
  'Purpose of Donation': 'عطیہ کا مقصد',
  Purpose: 'مقصد',
  'Purpose details': 'مقصد کی تفصیل',
  'Tell us a little more': 'ہمیں کچھ مزید بتائیں',
  'In memory of…': 'کی یاد میں…',
  'Proceed to Payment': 'ادائیگی کی طرف',
  'Continue to Donor Info': 'عطیہ دہندہ کی معلومات',
  'Continue to Recipient Info': 'وصول کنندہ کی معلومات',
  'Previous month': 'پچھلا مہینہ',
  'Next month': 'اگلا مہینہ',
  'Close calendar': 'کیلنڈر بند کریں',

  'Donor Information': 'عطیہ دہندہ کی معلومات',
  'All optional — donate anonymously if you prefer':
    'سب اختیاری ہے — چاہیں تو نام ظاہر کیے بغیر عطیہ کریں',
  'Full Name': 'پورا نام',
  'Mobile Number': 'موبائل نمبر',
  'Email Address': 'ای میل ایڈریس',
  Optional: 'اختیاری',
  'Privacy & Updates': 'رازداری اور اطلاعات',
  'I would like to receive updates about my donation and impact.':
    'میں اپنے عطیہ اور اس کے اثر کے بارے میں اطلاعات وصول کرنا چاہتا/چاہتی ہوں۔',
  'Please keep me anonymous': 'میرا نام ظاہر نہ کریں',
  'Add an email address if you would like to receive these.':
    'یہ وصول کرنا چاہیں تو ای میل ایڈریس لکھیں۔',
  'Your name will not be shown anywhere.': 'آپ کا نام کہیں ظاہر نہیں کیا جائے گا۔',
  'Send me photos from the distribution': 'مجھے تقسیم کی تصاویر بھیجیں',

  'Recipient Information': 'وصول کنندہ کی معلومات',
  'Where the meals go, and who receives them': 'کھانا کہاں جائے گا اور کون وصول کرے گا',
  'Which city should the meals go to?': 'کھانا کس شہر میں بھیجا جائے؟',
  'Select a city': 'شہر منتخب کریں',
  City: 'شہر',
  'Delivery / Recipient Information': 'ترسیل / وصول کنندہ کی معلومات',
  'Optional. Leave it blank and we will give the meals to whoever needs them most.':
    'اختیاری۔ خالی چھوڑ دیں تو ہم کھانا سب سے زیادہ ضرورت مند کو دے دیں گے۔',
  'Recipient name': 'وصول کنندہ کا نام',
  "Optional — a specific person, if you have one in mind":
    'اختیاری — کوئی مخصوص شخص، اگر آپ کے ذہن میں ہو',
  "Recipient's number": 'وصول کنندہ کا نمبر',
  'Whoever will receive the meals': 'جو کھانا وصول کرے گا',
  Instructions: 'ہدایات',
  'e.g. Please deliver to any needy person you find.':
    'مثلاً: جو ضرورت مند ملے اسے پہنچا دیں۔',
  'I need evidence of distribution': 'مجھے تقسیم کا ثبوت چاہیے',
  'We will not close your donation until the distribution has been evidenced.':
    'جب تک تقسیم کا ثبوت نہ مل جائے ہم آپ کا عطیہ مکمل نہیں کریں گے۔',
  'Doorstep delivery': 'گھر پر ترسیل',
  'Address Details': 'پتے کی تفصیل',
  Address: 'پتہ',
  'House and street': 'مکان اور گلی',
  Area: 'علاقہ',
  Landmark: 'قریبی نشانی',
  'Optional — helps the rider find you': 'اختیاری — رائیڈر کو آپ تک پہنچنے میں مدد ملتی ہے',
  'Contact Number': 'رابطہ نمبر',
  'Distribution Location': 'تقسیم کی جگہ',

  'Make Payment': 'ادائیگی کریں',
  Payment: 'ادائیگی',
  'Choose a payment method and complete your donation':
    'ادائیگی کا طریقہ منتخب کریں اور عطیہ مکمل کریں',
  'Payment method': 'ادائیگی کا طریقہ',
  'Payment Method': 'ادائیگی کا طریقہ',
  'Payment Methods': 'ادائیگی کے طریقے',
  'Payment methods unavailable': 'ادائیگی کے طریقے دستیاب نہیں',
  'We could not load the ways to pay. Please try again.':
    'ہم ادائیگی کے طریقے لوڈ نہیں کر سکے۔ براہِ کرم دوبارہ کوشش کریں۔',
  'Your payment is secure and encrypted. We never store your card details.':
    'آپ کی ادائیگی محفوظ اور خفیہ ہے۔ ہم آپ کے کارڈ کی تفصیل کبھی محفوظ نہیں کرتے۔',
  'Your donation is secure and encrypted.': 'آپ کا عطیہ محفوظ اور خفیہ ہے۔',

  'Review Your Donation': 'اپنے عطیہ پر نظرثانی کریں',
  'Please review your details before confirming': 'تصدیق سے پہلے اپنی تفصیلات دیکھ لیں',
  'Confirm Order': 'آرڈر کی تصدیق کریں',
  'Total Donation': 'کل عطیہ',
  'We could not complete your donation': 'ہم آپ کا عطیہ مکمل نہیں کر سکے',

  // ----------------------------------------------------------- thank you
  'Thank You!': 'شکریہ!',
  'JazakAllah!': 'جزاک اللہ!',
  'Order Successful': 'آرڈر کامیاب',
  'Your order has been confirmed.': 'آپ کے آرڈر کی تصدیق ہو گئی ہے۔',
  'Your order reference': 'آپ کے آرڈر کا حوالہ نمبر',
  "You've just helped provide nutritious meals to those who need them the most.":
    'آپ نے ابھی ان لوگوں تک غذائیت بخش کھانا پہنچانے میں مدد کی جنہیں اس کی سب سے زیادہ ضرورت ہے۔',
  "We'll notify you at every step until your donation is completed.":
    'عطیہ مکمل ہونے تک ہم ہر مرحلے پر آپ کو اطلاع دیں گے۔',
  'Need help with this order?': 'اس آرڈر کے بارے میں مدد چاہیے؟',
  'Order More': 'مزید آرڈر کریں',
  'Back to Home': 'ہوم پر واپس',
  'Back to Tracking': 'ٹریکنگ پر واپس',
  'View Receipt': 'رسید دیکھیں',
  'A note from the team': 'ٹیم کی طرف سے',
  'Thank you for helping feed people in need.':
    'ضرورت مندوں کو کھانا کھلانے میں مدد کرنے پر شکریہ۔',
  'Thank you for making a difference!': 'فرق پیدا کرنے پر شکریہ!',

  // ------------------------------------------------------- my donations
  'Track and manage your donations': 'اپنے عطیات دیکھیں اور سنبھالیں',
  'No donations yet': 'ابھی کوئی عطیہ نہیں',
  'Sponsor your first meal and your impact will start building here.':
    'اپنا پہلا کھانا عطیہ کریں، آپ کا اثر یہیں سے بننا شروع ہو گا۔',
  'We could not load your donations': 'ہم آپ کے عطیات لوڈ نہیں کر سکے',
  'Tap to track your order.': 'آرڈر ٹریک کرنے کے لیے دبائیں۔',
  'Donation Progress': 'عطیہ کی پیش رفت',
  'Tracking unavailable': 'ٹریکنگ دستیاب نہیں',
  "We could not load this donation's progress.": 'ہم اس عطیہ کی پیش رفت لوڈ نہیں کر سکے۔',
  'View Distribution Proof': 'تقسیم کا ثبوت دیکھیں',
  'Donation Completed!': 'عطیہ مکمل ہو گیا!',
  'Distribution Photos': 'تقسیم کی تصاویر',
  'These photos were shared with your permission.':
    'یہ تصاویر آپ کی اجازت سے شیئر کی گئی ہیں۔',
  'Not distributed yet': 'ابھی تقسیم نہیں ہوا',
  "We'll share the details as soon as your meals have been distributed.":
    'کھانا تقسیم ہوتے ہی ہم آپ کو تفصیل بھیج دیں گے۔',
  'Photos from this distribution are not available yet.':
    'اس تقسیم کی تصاویر ابھی دستیاب نہیں ہیں۔',
  'Loading distribution details': 'تقسیم کی تفصیل لوڈ ہو رہی ہے',

  // -------------------------------------------------------------- impact
  'Your Impact': 'آپ کا اثر',
  'Overall Impact': 'مجموعی اثر',
  'Your Contributions': 'آپ کے عطیات',
  'Your contributions are unavailable': 'آپ کے عطیات دستیاب نہیں',
  'Statistics unavailable': 'اعداد و شمار دستیاب نہیں',
  'We could not load the impact figures.': 'ہم اثر کے اعداد و شمار لوڈ نہیں کر سکے۔',
  'We could not load your totals just now.': 'ہم ابھی آپ کے کل اعداد لوڈ نہیں کر سکے۔',
  'People Served': 'کھانا پانے والے افراد',
  'Total Donations': 'کل عطیات',
  'Total Amount Donated': 'کل عطیہ کی گئی رقم',
  'Total People Helped': 'کل مستفید افراد',
  "You're Making a Difference!": 'آپ فرق پیدا کر رہے ہیں!',
  "You're Making an Impact!": 'آپ کا اثر بن رہا ہے!',
  "Every meal you sponsor brings hope and happiness to someone's life.":
    'آپ کا عطیہ کیا گیا ہر کھانا کسی کی زندگی میں امید اور خوشی لاتا ہے۔',
  'See how your donation makes an impact': 'دیکھیں آپ کا عطیہ کیا اثر ڈالتا ہے',

  // -------------------------------------------------------------- receipt
  'Your donation receipt': 'آپ کے عطیہ کی رسید',
  'Receipt unavailable': 'رسید دستیاب نہیں',
  'Loading receipt': 'رسید لوڈ ہو رہی ہے',
  'Download Certificate': 'سرٹیفکیٹ ڈاؤن لوڈ کریں',

  // ------------------------------------------------------- notifications
  Notifications: 'اطلاعات',
  'Nothing yet': 'ابھی کچھ نہیں',
  'Updates about your donations will appear here.':
    'آپ کے عطیات کی اطلاعات یہاں دکھائی دیں گی۔',
  'Donation Updates': 'عطیہ کی اطلاعات',
  'Completion Notifications': 'تکمیل کی اطلاعات',

  // ------------------------------------------------------------- profile
  Account: 'اکاؤنٹ',
  'Personal Information': 'ذاتی معلومات',
  'Profile unavailable': 'پروفائل دستیاب نہیں',
  'Sign in to view and manage your account.':
    'اپنا اکاؤنٹ دیکھنے اور سنبھالنے کے لیے سائن اِن کریں۔',
  'See the donations made from this device': 'اس ڈیوائس سے کیے گئے عطیات دیکھیں',
  'Change Password': 'پاس ورڈ تبدیل کریں',
  Logout: 'لاگ آؤٹ',
  'Donation Preferences': 'عطیہ کی ترجیحات',
  'Donate Anonymously': 'نام ظاہر کیے بغیر عطیہ',
  'Your name will not be shown on new donations.':
    'نئے عطیات پر آپ کا نام ظاہر نہیں کیا جائے گا۔',
  'Default for new donations. Past donations keep the choice you made then.':
    'نئے عطیات کے لیے طے شدہ۔ پرانے عطیات پر آپ کا اُس وقت کا انتخاب برقرار رہے گا۔',
  'You can change this at any time in Settings.':
    'آپ اسے سیٹنگز میں کسی بھی وقت تبدیل کر سکتے ہیں۔',
  'Support & Legal': 'معاونت اور قانونی',
  'Privacy Policy': 'رازداری کی پالیسی',
  'Terms & Conditions': 'شرائط و ضوابط',
  'Privacy & Terms': 'رازداری اور شرائط',
  Partner: 'پارٹنر',

  // ------------------------------------------------------------- support
  'Help & Support': 'مدد اور معاونت',
  'Contact Us': 'ہم سے رابطہ',
  'Contact Support': 'معاونت سے رابطہ',
  "We're here to help you.": 'ہم آپ کی مدد کے لیے حاضر ہیں۔',
  'We would rather hear from you than have you wonder.':
    'آپ کے سوال کا جواب دینا ہمیں زیادہ پسند ہے۔',
  'No contact details yet': 'ابھی رابطہ کی تفصیل نہیں',
  'Support channels have not been set up. Please try again later.':
    'رابطہ کے ذرائع ابھی ترتیب نہیں دیے گئے۔ براہِ کرم بعد میں کوشش کریں۔',
  'Loading contact details': 'رابطہ کی تفصیل لوڈ ہو رہی ہے',
  'Email our support team': 'ہماری معاونت ٹیم کو ای میل کریں',
  'Loading steps': 'مراحل لوڈ ہو رہے ہیں',
  'Impact': 'اثر',
  'Settings': 'سیٹنگز',
  'You Choose': 'آپ منتخب کرتے ہیں',
  'Select a meal and number of people': 'کھانا اور افراد کی تعداد منتخب کریں',
  'You Pay': 'آپ ادائیگی کرتے ہیں',
  'Make a secure payment online': 'آن لائن محفوظ ادائیگی کریں',
  'We Prepare': 'ہم تیار کرتے ہیں',
  'We cook with care and hygiene': 'ہم صفائی اور خیال کے ساتھ پکاتے ہیں',
  'We Distribute': 'ہم تقسیم کرتے ہیں',
  'Meals are distributed to those in need': 'کھانا ضرورت مندوں میں تقسیم کیا جاتا ہے',
  'We Deliver & Distribute': 'ہم پہنچاتے اور تقسیم کرتے ہیں',
  'We Deliver & Distribute (Only in Lahore)': 'ہم پہنچاتے اور تقسیم کرتے ہیں (صرف لاہور میں)',
  'Meals go to people in need, or to a doorstep you choose if you pay for delivery': 'کھانا ضرورت مندوں تک جاتا ہے، یا ترسیل کی فیس دینے پر آپ کے بتائے پتے پر',
  'Evidence Is Captured': 'ثبوت محفوظ کیا جاتا ہے',
  'Photos or video of the distribution, recorded as it happens': 'تقسیم کے وقت کی تصاویر یا ویڈیو، اُسی وقت ریکارڈ کی گئی',
  'You Get Update': 'آپ کو اطلاع ملتی ہے',
  'You receive confirmation with impact': 'آپ کو تصدیق اور اثر کی تفصیل ملتی ہے',
  'Sadaqah / Charity': 'صدقہ / خیرات',
  'In Memory of Someone': 'کسی کی یاد میں',
  'General Charity': 'عام خیرات',
  'Other': 'دیگر',
  'Meals Served': 'فراہم کیے گئے کھانے',
  'Happy Donors': 'خوش عطیہ دہندگان',
  'Cities': 'شہر',
  'Partner Organizations': 'شراکت دار ادارے',
  'How Donations Work': 'عطیہ کیسے کام کرتا ہے',
  'Learn how your donation helps': 'جانیے آپ کا عطیہ کیسے مدد کرتا ہے',
  'Payment Issues': 'ادائیگی کے مسائل',
  'Facing problems with payment?': 'ادائیگی میں مشکل پیش آ رہی ہے؟',
  'Cancellation & Refunds': 'منسوخی اور رقم کی واپسی',
  'Our cancellation and refund policy': 'ہماری منسوخی اور رقم واپسی کی پالیسی',
  'Distribution Questions': 'تقسیم سے متعلق سوالات',
  'Have questions about distribution?': 'تقسیم کے بارے میں سوال ہے؟',
  'Frequently asked questions': 'اکثر پوچھے جانے والے سوالات',
  'Opens WhatsApp': 'واٹس ایپ کھولتا ہے',
  'Opens your mail app': 'آپ کی ای میل ایپ کھولتا ہے',
  'Opens your dialler': 'آپ کا ڈائلر کھولتا ہے',
  'Opens in your browser': 'آپ کے براؤزر میں کھلتا ہے',
  'Charity Distribution': 'خیراتی تقسیم',
  'We give the meals to people in need. Included.': 'ہم کھانا ضرورت مندوں کو دیتے ہیں۔ قیمت میں شامل ہے۔',
  'Doorstep Delivery — Paid': 'گھر پر ترسیل — اضافی فیس',
  'Only within Lahore': 'صرف لاہور کے اندر',
  'delivery fee': 'ترسیل کی فیس',
  'Change': 'تبدیل کریں',
  'Select a date': 'تاریخ منتخب کریں',
  'Choose a meal': 'کھانا منتخب کریں',
  'Choose how many people': 'افراد کی تعداد منتخب کریں',
  'Other (type your city)': 'دیگر (اپنا شہر لکھیں)',
  'Your city': 'آپ کا شہر',
  'Your City': 'آپ کا شہر',
  'Type your city': 'اپنا شہر لکھیں',
  'Enter your city.': 'اپنا شہر لکھیں۔',
  'Active': 'جاری',
  'All': 'سب',
  'Cancelled': 'منسوخ شدہ',
  'Completed': 'مکمل',
  'Distributed': 'تقسیم ہو گیا',
  'Donation Created': 'عطیہ درج ہوا',
  'Failed': 'ناکام',
  'Food Preparing': 'کھانا تیار ہو رہا ہے',
  'In Progress': 'جاری ہے',
  'Newest first': 'نئے پہلے',
  'Not Scheduled': 'شیڈول نہیں',
  'Oldest first': 'پرانے پہلے',
  'Order Accepted': 'آرڈر منظور',
  'Paid': 'ادا شدہ',
  'Payment Confirmed': 'ادائیگی کی تصدیق',
  'Payment Failed': 'ادائیگی ناکام',
  'Pending': 'زیرِ التوا',
  'Processing': 'کارروائی جاری',
  'Ready': 'تیار',
  'Ready for Distribution': 'تقسیم کے لیے تیار',
  'Refund Pending': 'رقم واپسی زیرِ التوا',
  'Refunded': 'رقم واپس',
  'Scheduled': 'شیڈول شدہ',
  'Unscheduled': 'بغیر شیڈول',
  'Upcoming distribution': 'آنے والی تقسیم',
  'Status': 'حالت',
  'No donations': 'کوئی عطیہ نہیں',
  'Pay': 'ادا کریں',
  'per person': 'فی فرد',
  'No email provided': 'کوئی ای میل نہیں دی گئی',
  'will be fed on': 'کو کھانا ملے گا',
  'FAQ': 'عمومی سوالات',
  'Distribution': 'تقسیم',
  'Donated': 'عطیہ کیا',
  'Easypaisa account number': 'ایزی پیسہ اکاؤنٹ نمبر',
  'You will approve the payment on this phone.': 'آپ اس فون پر ادائیگی کی منظوری دیں گے۔',
  'Enter the Easypaisa mobile account number, e.g. 03001234567.':
    'ایزی پیسہ موبائل اکاؤنٹ نمبر لکھیں، مثلاً 03001234567۔',
  'Approve on your phone': 'اپنے فون پر منظوری دیں',
  'Open the Easypaisa notification on your phone and enter your PIN.':
    'اپنے فون پر ایزی پیسہ کی اطلاع کھولیں اور اپنا پن درج کریں۔',
  'Waiting for your approval…': 'آپ کی منظوری کا انتظار ہے…',
  'Payment not completed': 'ادائیگی مکمل نہیں ہوئی',
  'The payment was not approved in Easypaisa.': 'ایزی پیسہ میں ادائیگی کی منظوری نہیں دی گئی۔',
  'The Easypaisa approval request expired.': 'ایزی پیسہ کی منظوری کی درخواست ختم ہو گئی۔',
  'Choose another way to pay': 'ادائیگی کا کوئی اور طریقہ منتخب کریں',
  'We have not heard from Easypaisa yet. If you approved, your donation will update shortly.':
    'ایزی پیسہ سے ابھی جواب نہیں آیا۔ اگر آپ نے منظوری دی ہے تو آپ کا عطیہ جلد اپ ڈیٹ ہو جائے گا۔',
  'DEMO': 'ڈیمو',
  'No real phone in the demo. Choose what the donor does:': 'ڈیمو میں اصل فون نہیں ہے۔ منتخب کریں کہ عطیہ دہندہ کیا کرے:',
  'Approve': 'منظور کریں',
  'Payment cancelled': 'ادائیگی منسوخ ہو گئی',
  'Complete your payment': 'اپنی ادائیگی مکمل کریں',
  'You left the payment page before paying. Nothing was charged.':
    'آپ ادائیگی کیے بغیر ادائیگی کا صفحہ چھوڑ آئے۔ کوئی رقم نہیں کٹی۔',
  'Try again': 'دوبارہ کوشش کریں',
  'No payment methods available': 'ادائیگی کا کوئی طریقہ دستیاب نہیں',
  'Online payment is not set up yet. Please try again later, or contact us to donate.':
    'آن لائن ادائیگی ابھی ترتیب نہیں دی گئی۔ براہِ کرم بعد میں کوشش کریں، یا عطیہ کے لیے ہم سے رابطہ کریں۔',
  "Pay on Stripe's secure page. This screen updates as soon as you have paid.":
    'اسٹرائپ کے محفوظ صفحے پر ادائیگی کریں۔ ادائیگی ہوتے ہی یہ اسکرین اپ ڈیٹ ہو جائے گی۔',
  "Pay on JazzCash's secure page. This screen updates as soon as you have paid.":
    'جاز کیش کے محفوظ صفحے پر ادائیگی کریں۔ ادائیگی ہوتے ہی یہ اسکرین اپ ڈیٹ ہو جائے گی۔',
  'Open secure payment page': 'محفوظ ادائیگی کا صفحہ کھولیں',
  'TEST MODE': 'ٹیسٹ موڈ',
  'No real money moves. Pay with the test card 4242 4242 4242 4242, any future expiry date and any 3-digit CVC.':
    'کوئی اصل رقم منتقل نہیں ہوتی۔ ٹیسٹ کارڈ 4242 4242 4242 4242، کوئی بھی آئندہ کی میعاد اور کوئی بھی 3 ہندسوں کا CVC استعمال کریں۔',
  'Waiting for the payment…': 'ادائیگی کا انتظار ہے…',
  'We have not heard back yet. If you paid, your donation will update shortly.':
    'ابھی جواب نہیں آیا۔ اگر آپ نے ادائیگی کر دی ہے تو آپ کا عطیہ جلد اپ ڈیٹ ہو جائے گا۔',
  'The payment was not completed.': 'ادائیگی مکمل نہیں ہوئی۔',
  'The secure payment page expired before the payment was made.':
    'ادائیگی ہونے سے پہلے محفوظ ادائیگی کا صفحہ ختم ہو گیا۔',
  'The card payment was not completed.': 'کارڈ سے ادائیگی مکمل نہیں ہوئی۔',
  'The JazzCash payment was not completed.': 'جاز کیش سے ادائیگی مکمل نہیں ہوئی۔',
  'Your Easypaisa account does not have enough balance for this payment.':
    'آپ کے ایزی پیسہ اکاؤنٹ میں اس ادائیگی کے لیے کافی رقم نہیں ہے۔',
  'That number is not an active Easypaisa account.': 'یہ نمبر فعال ایزی پیسہ اکاؤنٹ نہیں ہے۔',
  'Easypaisa could not start the payment. Check the number and try again.':
    'ایزی پیسہ ادائیگی شروع نہیں کر سکا۔ نمبر چیک کر کے دوبارہ کوشش کریں۔',
  'Enter the Easypaisa mobile account number to pay from, e.g. 03001234567.':
    'جس ایزی پیسہ موبائل اکاؤنٹ سے ادائیگی کرنی ہے اس کا نمبر لکھیں، مثلاً 03001234567۔',
  'Decline': 'مسترد کریں',
  'Fewer people': 'کم افراد',
  'More people': 'زیادہ افراد',
  'Switch to counter': 'کاؤنٹر پر جائیں',
  'Switch to tiles': 'خانوں پر جائیں',
  'Switch to card layout': 'کارڈ ترتیب پر جائیں',
  'Switch to list layout': 'فہرست ترتیب پر جائیں',
  'Donation': 'عطیہ',
  'Your kindness brings hope and fills plates. Thank you for being a part of this mission.':
    'آپ کی مہربانی امید دیتی ہے اور پلیٹیں بھرتی ہے۔ اس مشن کا حصہ بننے پر شکریہ۔',
  'Price per person': 'فی فرد قیمت',
  WhatsApp: 'واٹس ایپ',
  Email: 'ای میل',
  Call: 'کال',
  Website: 'ویب سائٹ',

  // -------------------------------------------------------------- tiffin
  'New Features': 'نئی سہولتیں',
  'More features coming soon': 'مزید سہولتیں جلد آ رہی ہیں',
  'We are building more ways to give and to follow your donation. In the meantime you can sponsor a meal and track it all the way to the people who receive it.':
    'ہم عطیہ دینے اور اس کی پیش رفت جاننے کے مزید طریقے بنا رہے ہیں۔ تب تک آپ کھانے کا عطیہ دے سکتے ہیں اور اسے وصول کرنے والوں تک پہنچنے تک دیکھ سکتے ہیں۔',
  'Get a nutritious meal delivered to your doorstep.': 'غذائیت سے بھرپور کھانا، آپ کی دہلیز تک۔',
  'Contribute towards meals for those in need.': 'ضرورت مندوں کے کھانوں میں اپنا حصہ ڈالیں۔',
  "Explore what's new in Meal4ALL.": 'دیکھیں Meal4ALL میں نیا کیا ہے۔',
  'View and track your orders.': 'اپنے آرڈرز دیکھیں اور ان کی پیش رفت جانیں۔',
  'Healthy and balanced meals for a better tomorrow.': 'بہتر کل کے لیے صحت بخش اور متوازن کھانے۔',
  'Meals are prepared with care and hygiene.': 'کھانے احتیاط اور صفائی سے تیار کیے جاتے ہیں۔',
  'Your contribution reaches those in need with love and care.':
    'آپ کا تعاون محبت اور توجہ کے ساتھ ضرورت مندوں تک پہنچتا ہے۔',
  'Order a Tiffin': 'ٹفن آرڈر کریں',
  'My Tiffin Orders': 'میرے ٹفن آرڈرز',
  Tiffin: 'ٹفن',
  Breakfast: 'ناشتہ',
  Lunch: 'دوپہر کا کھانا',
  Dinner: 'رات کا کھانا',
  'Your Tiffin': 'آپ کا ٹفن',
  'Your tiffin': 'آپ کا ٹفن',
  'Build Your Tiffin': 'اپنا ٹفن بنائیں',
  'Choose the meal, then what goes in each box': 'کھانے کا وقت منتخب کریں، پھر ہر باکس میں کیا ہو',
  Day: 'دن',
  Meal: 'کھانا',
  Closed: 'بند',
  Add: 'شامل کریں',
  'One more': 'ایک اور',
  'One fewer': 'ایک کم',
  'Up to': 'زیادہ سے زیادہ',
  'in each box': 'ہر باکس میں',
  'In each box': 'ہر باکس میں',
  'One box': 'ایک باکس',
  'Your box': 'آپ کا باکس',
  item: 'آئٹم',
  items: 'آئٹمز',
  'Per person, per meal': 'فی فرد، فی کھانا',
  'Your plan, then what goes in each box': 'آپ کا پلان، پھر ہر باکس میں کیا ہو',
  'Fill your box': 'اپنا باکس بھریں',
  'How often': 'کتنی بار',
  Daily: 'روزانہ',
  'Bi-weekly': 'ہفتے میں دو بار',
  Weekly: 'ہفتہ وار',
  Weekends: 'ویک اینڈ',
  'Every day': 'ہر روز',
  Mondays: 'پیر',
  Tuesdays: 'منگل',
  Wednesdays: 'بدھ',
  Thursdays: 'جمعرات',
  Fridays: 'جمعہ',
  Saturdays: 'ہفتہ',
  Sundays: 'اتوار',
  'How Many Persons': 'کتنے افراد',
  'Each person gets the box you built, at every meal': 'ہر کھانے پر ہر فرد کو آپ کا بنایا ہوا باکس ملے گا',
  'Contact Person': 'رابطہ کرنے والا فرد',
  'Who the kitchen and the rider call': 'کچن اور رائیڈر کس سے رابطہ کریں',
  'Delivery Info': 'ترسیل کی معلومات',
  'Pick & drop to your door, or collect it yourself': 'پک اینڈ ڈراپ آپ کے دروازے تک، یا خود وصول کریں',
  'Contact Info': 'رابطے کی معلومات',
  'a meal': 'فی کھانا',
  'Home-style meals, cooked fresh and brought to you.':
    'گھر جیسا کھانا، تازہ پکا ہوا اور آپ تک پہنچایا ہوا۔',
  'Choose breakfast, lunch or dinner, then fill one box from the menu.':
    'ناشتہ، دوپہر یا رات کا کھانا منتخب کریں، پھر مینو سے ایک باکس بھریں۔',
  'Choose How Often': 'منتخب کریں کتنی بار',
  'Start on any day, for at least {n} days in a row and up to {max}: {often}.':
    'کسی بھی دن سے شروع کریں، مسلسل کم از کم {n} اور زیادہ سے زیادہ {max} دن کے لیے: {often}۔',
  'Persons & Delivery': 'افراد اور ترسیل',
  'Say how many persons. We bring it to your door with pick & drop, {fee} a meal, or you collect it from our kitchen.':
    'بتائیں کتنے افراد ہیں۔ ہم پک اینڈ ڈراپ سے آپ کے دروازے تک پہنچائیں گے، فی کھانا {fee}، یا آپ ہمارے کچن سے وصول کر لیں۔',
  'Say how many persons. We bring it to your door with pick & drop, {fee} a meal.':
    'بتائیں کتنے افراد ہیں۔ ہم پک اینڈ ڈراپ سے آپ کے دروازے تک پہنچائیں گے، فی کھانا {fee}۔',
  'Say how many persons, then collect it from our kitchen.':
    'بتائیں کتنے افراد ہیں، پھر ہمارے کچن سے وصول کریں۔',
  'You Pay Securely': 'محفوظ ادائیگی کریں',
  'One box for each person at each meal, plus pick & drop for each meal. Pay online, once for the whole order.':
    'ہر کھانے پر ہر فرد کے لیے ایک باکس، اور ہر کھانے کا پک اینڈ ڈراپ۔ پورے آرڈر کی ادائیگی ایک ہی بار آن لائن کریں۔',
  'We Cook Fresh': 'ہم تازہ پکاتے ہیں',
  'Cooked fresh every day and brought to you, or ready to collect, at your meal time.':
    'ہر روز تازہ پکا کر آپ کے کھانے کے وقت پر پہنچایا جاتا ہے، یا وصولی کے لیے تیار ہوتا ہے۔',
  'Follow Every Step': 'ہر مرحلے سے باخبر رہیں',
  'See your order in My Orders, from accepted to delivered, and call us any time.':
    'میرے آرڈرز میں اپنا آرڈر قبول ہونے سے پہنچنے تک دیکھیں، اور کسی بھی وقت ہمیں کال کریں۔',
  'Meal times': 'کھانے کے اوقات',
  'Each meal stops taking orders a little before it is served; the menu shows when.':
    'ہر کھانے کے آرڈر اس کے وقت سے کچھ پہلے بند ہو جاتے ہیں؛ مینو میں وقت درج ہوتا ہے۔',
  Starting: 'آغاز',
  'Tiffin orders run for at least {n} days in a row, from this day.':
    'ٹفن کا آرڈر اس دن سے مسلسل کم از کم {n} دن کے لیے ہوتا ہے۔',
  'Add items from the menu': 'مینو سے آئٹمز شامل کریں',
  'Nothing is on the menu for this meal yet.': 'اس وقت کے کھانے کے لیے ابھی مینو میں کچھ نہیں۔',
  'Every meal on this day has closed for orders. Choose another day.':
    'اس دن کے تمام کھانوں کے آرڈر بند ہو چکے ہیں۔ کوئی اور دن منتخب کریں۔',
  'Tiffin ordering is not open yet': 'ٹفن کے آرڈر ابھی شروع نہیں ہوئے',
  'We are setting up our tiffin service. Please check back soon, or contact us.':
    'ہم اپنی ٹفن سروس ترتیب دے رہے ہیں۔ براہِ کرم جلد دوبارہ دیکھیں، یا ہم سے رابطہ کریں۔',
  'Tiffin orders are paused at the moment.': 'ٹفن کے آرڈر فی الحال بند ہیں۔',
  'That date has passed.': 'یہ تاریخ گزر چکی ہے۔',

  'How many persons?': 'کتنے افراد؟',
  'Each person gets the box you built.': 'ہر فرد کو آپ کا بنایا ہوا باکس ملے گا۔',
  Person: 'فرد',
  Persons: 'افراد',
  'Fewer persons': 'کم افراد',
  'More persons': 'زیادہ افراد',
  'At least': 'کم از کم',
  'For how many days?': 'کتنے دن کے لیے؟',
  Days: 'دن',
  'Fewer days': 'کم دن',
  'More days': 'زیادہ دن',
  'How should we hand it over?': 'کھانا آپ تک کیسے پہنچے؟',
  'Delivery option': 'ترسیل کا طریقہ',
  'Pick & Drop': 'پک اینڈ ڈراپ',
  'Pick & drop': 'پک اینڈ ڈراپ',
  'Self Pickup': 'خود وصولی',
  'Delivered to your address': 'آپ کے پتے پر پہنچایا جائے گا',
  'Collect from our kitchen': 'ہمارے کچن سے وصول کریں',
  'Delivery address': 'ترسیل کا پتہ',
  'e.g. House 4, Street 9': 'مثلاً مکان 4، گلی 9',
  'e.g. Johar Town': 'مثلاً جوہر ٹاؤن',
  'e.g. Near the park': 'مثلاً پارک کے قریب',
  'Your details': 'آپ کی تفصیلات',
  'The kitchen or rider calls this number.': 'کچن یا رائیڈر اسی نمبر پر رابطہ کرے گا۔',
  'Note for the kitchen': 'کچن کے لیے نوٹ',
  'e.g. Less spicy, ring twice': 'مثلاً کم مرچ، دو بار گھنٹی بجائیں',
  'Continue to Payment': 'ادائیگی کی طرف',

  'Choose how you would like to pay': 'منتخب کریں کہ آپ کیسے ادائیگی کریں گے',
  'Online payment is not set up yet. Please try again later, or contact us to order.':
    'آن لائن ادائیگی ابھی ترتیب نہیں دی گئی۔ براہِ کرم بعد میں کوشش کریں، یا آرڈر کے لیے ہم سے رابطہ کریں۔',

  'Review Your Order': 'اپنے آرڈر پر نظرثانی کریں',
  'Please check your order before confirming': 'تصدیق سے پہلے اپنا آرڈر دیکھ لیں',
  Served: 'اوقات',
  'Deliver to': 'ترسیل کا پتہ',
  'Delivered to': 'ترسیل کا پتہ',
  'Collect from': 'وصولی کی جگہ',
  Name: 'نام',
  Mobile: 'موبائل',
  Note: 'نوٹ',
  Method: 'طریقہ',
  Total: 'کل',
  'Place Order': 'آرڈر دیں',

  'Order Placed!': 'آرڈر ہو گیا!',
  'The kitchen has your order. We will keep you updated at every step.':
    'کچن کو آپ کا آرڈر مل گیا ہے۔ ہم ہر مرحلے پر آپ کو اطلاع دیتے رہیں گے۔',
  'Track Order': 'آرڈر ٹریک کریں',
  'Order Progress': 'آرڈر کی پیش رفت',
  'Order unavailable': 'آرڈر دستیاب نہیں',
  'We could not load this order.': 'ہم یہ آرڈر لوڈ نہیں کر سکے۔',
  Placed: 'آرڈر کا وقت',
  'Pull down to refresh. We update this order at every step.':
    'تازہ کرنے کے لیے نیچے کھینچیں۔ ہم ہر مرحلے پر یہ آرڈر اپ ڈیٹ کرتے ہیں۔',
  'No tiffin orders yet': 'ابھی کوئی ٹفن آرڈر نہیں',
  'Tiffins you order from this device appear here, with their progress.':
    'اس ڈیوائس سے آرڈر کیے گئے ٹفن اپنی پیش رفت کے ساتھ یہاں دکھائی دیں گے۔',

  'Order Placed': 'آرڈر درج ہوا',
  Preparing: 'تیار ہو رہا ہے',
  'Out for Delivery': 'ترسیل کے لیے روانہ',
  'Ready for Pickup': 'وصولی کے لیے تیار',
  Delivered: 'پہنچا دیا گیا',
  Collected: 'وصول کر لیا گیا',
  'We could not take your payment. You can try again.':
    'ہم آپ کی ادائیگی وصول نہیں کر سکے۔ آپ دوبارہ کوشش کر سکتے ہیں۔',
  'This order was cancelled.': 'یہ آرڈر منسوخ کر دیا گیا۔',
  'A refund is being processed.': 'رقم کی واپسی جاری ہے۔',
  'This order has been refunded.': 'اس آرڈر کی رقم واپس کر دی گئی ہے۔',
  'Enter your name.': 'اپنا نام لکھیں۔',
  'Enter a valid mobile number, for example 03001234567.':
    'درست موبائل نمبر لکھیں، مثلاً 03001234567۔',
  'Enter a valid email address.': 'درست ای میل ایڈریس لکھیں۔',
  'Enter the house and street to deliver to.': 'جس مکان اور گلی میں پہنچانا ہے وہ لکھیں۔',
  'Choose the city.': 'شہر منتخب کریں۔',
  'A tiffin is for at least one person.': 'ٹفن کم از کم ایک فرد کے لیے ہوتا ہے۔',
  'My Orders': 'میرے آرڈرز',
  'Your supported meals and tiffin orders': 'آپ کے تعاون شدہ کھانے اور ٹفن آرڈرز',
  'Meals you have supported': 'وہ کھانے جن میں آپ نے تعاون کیا',
  'Meal Supported': 'کھانے میں تعاون',
  'Meals Supported': 'تعاون شدہ کھانے',
  Supported: 'تعاون کیا',
  'No supported meals yet': 'ابھی کسی کھانے میں تعاون نہیں',
  Donations: 'عطیات',
  Upcoming: 'آنے والے',
  Ordered: 'آرڈر کیا',
  'No orders yet': 'ابھی کوئی آرڈر نہیں',
  'No orders': 'کوئی آرڈر نہیں',
  'Try a different filter to see your other orders.':
    'اپنے دوسرے آرڈرز دیکھنے کے لیے کوئی اور فلٹر منتخب کریں۔',
  'Meals you support and tiffins you order from this device appear here, with their progress.':
    'اس ڈیوائس سے جن کھانوں میں آپ تعاون کریں اور جو ٹفن آرڈر کریں، وہ اپنی پیش رفت کے ساتھ یہاں دکھائی دیں گے۔',
  'We could not load your orders': 'ہم آپ کے آرڈرز لوڈ نہیں کر سکے',
};
